module.exports = __webpack_public_path__ + "img/wolverine.7a14adc9.png";